
export interface ConfirmRequest {
  /** Short dialog title (plain language, no em dashes). */
  readonly title: string;
  /** Body text explaining what the confirm action will do. */
  readonly message: string;
  /** Label for the affirmative button (e.g. "Replace"). */
  readonly confirmLabel: string;
  /** Label for the dismiss button (e.g. "Cancel"). */
  readonly cancelLabel: string;
}

type ConfirmSink = (request: ConfirmRequest) => Promise<boolean>;

let sink: ConfirmSink | null = null;

export function registerConfirmSink(next: ConfirmSink): () => void {
  sink = next;
  return () => {
    if (sink === next) sink = null;
  };
}


export function requestConfirm(request: ConfirmRequest): Promise<boolean> {
  return sink ? sink(request) : Promise.resolve(false);
}
